import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { ProductInterface } from 'domains/Orders/components/ProductSearcher/types';

export const SELECTED_PRODUCTS_LIMIT = 5000;

export type TransferProductVariant = ProductInterface<false> & {
  quantity?: number;
};

export type TransferProduct = Pick<
  ProductInterface<false>,
  'productId' | 'name' | 'imageUrl' | 'visible'
>;

export const extractTransferProduct = (products: ProductInterface<false>[]) => {
  const uniqueProducts = new Map<string, TransferProduct>();

  products.forEach((product) => {
    if (!uniqueProducts.has(product.productId)) {
      uniqueProducts.set(product.productId, {
        productId: product.productId,
        name: product.name,
        imageUrl: product.imageUrl,
        visible: product.visible,
      });
    }
  });

  return Array.from(uniqueProducts.values());
};

export const extractTransferProductDetails = (
  products: ProductTransferDetailsResponseDto['productVariants'],
) => {
  const uniqueProducts = new Map<string, TransferProduct>();

  products.forEach((product) => {
    if (!uniqueProducts.has(product.productId)) {
      uniqueProducts.set(product.productId, {
        productId: product.productId,
        name: product.productName,
        imageUrl: product.productImage,
        visible: product.productPublished,
      });
    }
  });

  return Array.from(uniqueProducts.values());
};
